import React from 'react'
import PropTypes from 'prop-types'

import InputsPresetEdit from '../forms/InputsPresetEdit'
import ExportSroiButton from '../ExportSroiButton'
import YearFilter from '../YearFilter'

import useStyles from './styles'

const SectionHeaderRightPanel = ({ selectedYear, setSelectedYear }) => {
  const classes = useStyles()

  return (
    <div className={classes.rightPanel}>
      <InputsPresetEdit />
      <ExportSroiButton />
      <YearFilter selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
    </div>
  )
}

SectionHeaderRightPanel.propTypes = {
  selectedYear: PropTypes.string,
  setSelectedYear: PropTypes.func.isRequired
}

export default SectionHeaderRightPanel
